import React, { useEffect } from 'react';
import { Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import AppIntegrationDetails from './MarketplaceDetails';
import BreadCrumb from 'Components/Common/BreadCrumb';
import { useCompanyName } from 'Components/Common/ThemeSettings/themeutitlity';

const index = (props: any) => {  

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid> 
                    <BreadCrumb title={"Meta Ads"} pageTitle={"App Marketplace"} />
                   <AppIntegrationDetails />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withTranslation()(index);

